// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './Water.module.scss';
// =========================

type Props = {
    children: React.ReactNode;
    useAnimations: boolean;
};

export default function Water({ children, useAnimations }: Props) {
    return (
        <div styleName="water">
            {children}
            <svg
                style={{ overflow: 'visible' }}
                styleName="left-lilypad"
                xmlns="http://www.w3.org/2000/svg"
                width="484.078"
                height="386.8"
                viewBox="0 0 484.078 386.8"
            >
                <g
                    id="Group_561"
                    data-name="Group 561"
                    transform="translate(-1373 -5034.29)"
                >
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, 4, -8, 0, -8, 4, -4, 8, 0],
                                y: [0, 8, 4, 0, -8, 4, -8, -4, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_841"
                            data-name="Path 841"
                            d="M1901.9,573.29c23.989,0,0,89.962,0,89.962s89.741-25.637,89.741,0A89.741,89.741,0,1,1,1901.9,573.29"
                            transform="translate(-185.894 4461)"
                            fill="#3edc89"
                        />
                    </motion.g>
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, 8, -4, 0, -4, 4, -8, 8, 0],
                                y: [0, 6, 2, 0, -4, 8, -4, 6, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_843"
                            data-name="Path 843"
                            d="M1639.7,677.119c16.109-29.136,108.724,60.418,108.724,60.418s29.281-126.211,60.261-109A124.545,124.545,0,1,1,1639.494,677.5c.069-.127.139-.252.208-.377"
                            transform="translate(-251 4479.559)"
                            fill="#3edc89"
                        />
                    </motion.g>
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, -2, 6, 3, -6, 2, -8, -2, 0],
                                y: [0, 6, -2, 6, -3, 5, -4, 3, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_845"
                            data-name="Path 845"
                            d="M1982.262,783.192c8.986,22.3-83.206,33.7-83.206,33.7s57.332,73.812,33.618,83.412a89.932,89.932,0,1,1,49.587-117.116v0"
                            transform="translate(-187.004 4514.184)"
                            fill="#3edc89"
                        />
                    </motion.g>
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, -4, 3, 0, -4, 2, -6, 4, 0],
                                y: [0, 3, 7, 0, -8, 4, -6, 4, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_847"
                            data-name="Path 847"
                            d="M1999.478,704.633c6.753,7.259-27.091,25.326-27.091,25.326s32.984,19.941,25.263,27.16a37.093,37.093,0,1,1,1.828-52.486"
                            transform="translate(-143.292 4502.375)"
                            fill="#3edc89"
                        />
                    </motion.g>
                </g>
            </svg>
            <svg
                style={{ overflow: 'visible' }}
                styleName="right-lilypad"
                xmlns="http://www.w3.org/2000/svg"
                width="484.078"
                height="386.8"
                viewBox="0 0 484.078 386.8"
            >
                <g
                    id="Group_561"
                    data-name="Group 561"
                    transform="translate(-1373 -5034.29)"
                >
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, 8, -4, 0, -4, 4, -8, 8, 0],
                                y: [0, 6, 2, 0, -4, 8, -4, 6, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_841"
                            data-name="Path 841"
                            d="M1901.9,573.29c23.989,0,0,89.962,0,89.962s89.741-25.637,89.741,0A89.741,89.741,0,1,1,1901.9,573.29"
                            transform="translate(-185.894 4461)"
                            fill="#3edc89"
                        />
                    </motion.g>
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, -2, 6, 3, -6, 2, -8, -2, 0],
                                y: [0, 6, -2, 6, -3, 5, -4, 3, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_843"
                            data-name="Path 843"
                            d="M1639.7,677.119c16.109-29.136,108.724,60.418,108.724,60.418s29.281-126.211,60.261-109A124.545,124.545,0,1,1,1639.494,677.5c.069-.127.139-.252.208-.377"
                            transform="translate(-251 4479.559)"
                            fill="#3edc89"
                        />
                    </motion.g>
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, -4, 3, 0, -4, 2, -6, 4, 0],
                                y: [0, 3, 7, 0, -8, 4, -6, 4, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_845"
                            data-name="Path 845"
                            d="M1982.262,783.192c8.986,22.3-83.206,33.7-83.206,33.7s57.332,73.812,33.618,83.412a89.932,89.932,0,1,1,49.587-117.116v0"
                            transform="translate(-187.004 4514.184)"
                            fill="#3edc89"
                        />
                    </motion.g>
                    <motion.g
                        animate={
                            useAnimations && {
                                x: [0, 4, -8, 0, -8, 4, -4, 8, 0],
                                y: [0, 8, 4, 0, -8, 4, -8, -4, 0],
                            }
                        }
                        transition={{
                            duration: 20,
                            bounce: 1,
                            repeat: Infinity,
                        }}
                    >
                        <path
                            id="Path_847"
                            data-name="Path 847"
                            d="M1999.478,704.633c6.753,7.259-27.091,25.326-27.091,25.326s32.984,19.941,25.263,27.16a37.093,37.093,0,1,1,1.828-52.486"
                            transform="translate(-143.292 4502.375)"
                            fill="#3edc89"
                        />
                    </motion.g>
                </g>
            </svg>
        </div>
    );
}
